import type { ICON_CARD_DATA, ICON_CARD_PARAMS, ICON_CARD_PARAMS_DEVICE } from './types'
import { DEFAULT_MARGIN, DEFAULT_PADDING, DEFAULT_WIDTH } from '@@/shared-components/content/const'

export const DEFAULT_ICON_CARD_DATA = (): ICON_CARD_DATA => ({
  id: null,
  classes: null,
  styles: null,
  type: 'icon-card',
  icon: 'far fa-star',
  title: 'Nadpis karty',
  text: 'Krátký popis, který upřesní, co člen získá.',
  comingSoon: false,
})

const DEFAULT_ICON_CARD_PARAMS_DEVICE = (): ICON_CARD_PARAMS_DEVICE => ({
  hidden: false,
  textAlign: 'center',
  iconColor: null,
  titleColor: null,
  textColor: null,
  iconSize: { value: 60, unit: 'px' },
  width: DEFAULT_WIDTH(),
  padding: DEFAULT_PADDING(),
  margin: DEFAULT_MARGIN(),
})

export const DEFAULT_ICON_CARD_PARAMS = (): ICON_CARD_PARAMS => ({
  pc: DEFAULT_ICON_CARD_PARAMS_DEVICE(),
  tablet: DEFAULT_ICON_CARD_PARAMS_DEVICE(),
  mobile: DEFAULT_ICON_CARD_PARAMS_DEVICE(),
})
